import SelectedStateIndicator from "@/components/SelectedStateIndicator";
import ContentLevel from "@/types/models/ContentLevel.interface";
import { EventProperties } from "@/types/models/EventProperties.interface";
import ActionsDropdown from "@/view/ActionsDropdown";

interface RenderLevels {
  closeDropdown: () => () => boolean;
  eventProperties: EventProperties;
  currentLevel: ContentLevel;
  levels: ContentLevel[];
  setCurrentLevel: (level: ContentLevel) => ContentLevel;
}

export const renderLevels = ({
  currentLevel,
  closeDropdown,
  eventProperties,
  levels,
  setCurrentLevel,
}: RenderLevels) => {
  if (!levels) return null;

  return levels.map((level, index) => {
    const isSelected = level.lexile === currentLevel?.lexile;
    const lexileLabel = index === 0 ? "MAX" : level.lexile;

    const onClick = () => {
      setCurrentLevel(level);
      closeDropdown();
    };

    const dropdownEventProperties = {
      ...eventProperties,
      streamProperties: {
        content_id: level.id,
        description: `Change article level to ${level.lexile}.`,
      },
    };

    return (
      <ActionsDropdown.ButtonItem
        dataProps={{ "data-qa-selector": `lexile option: ${level.lexile}` }}
        onClick={onClick}
        key={level.lexile}
        isSelected={isSelected}
        eventProperties={dropdownEventProperties}
      >
        <SelectedStateIndicator shouldDisplay={isSelected} />
        {lexileLabel}
      </ActionsDropdown.ButtonItem>
    );
  });
};

export default renderLevels;
